<template>
  <div class="d-flex w-100 overflow-hidden">
    <!-- SideNav -->
    <div id="sidenav-container">
      <AppConfigNav />
    </div>

    <div class="body-footer-container d-flex flex-column w-100 overflow-x-hidden ps-lg-5 vh-100"
      data-smooth-scroll="main"
    >
      <!-- Body -->
      <div class="body-container flex-lg-grow-1 mb-6">
        <div class="px-3 px-lg-0 py-lg-0" :class="{'customized-affiliate': !!affiliateCustomizations}">
          <slot />
        </div>
      </div>

      <!-- Footer -->
      <div class="footer-container">
        Footer!!
      </div>
    </div>
  </div>
</template>

<script>
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import { storeToRefs } from 'pinia'

export default {
  setup() {
    const affiliateCustomizationsStore = useAffiliateCustomizationStore()
    const { affiliateCustomizations } = storeToRefs(affiliateCustomizationsStore)

    return { affiliateCustomizations }
  }
}
</script>

<style lang="scss" scoped>
.body-footer-container {
  @include media-breakpoint-up(lg) {
    margin-left: $sidenav-width;
  }
  &> .body-container {
    padding-top: $navbar-height;

    max-width: 365px;
    @include media-breakpoint-up(lg) {
      max-width: 480px;
    }
    @include media-breakpoint-up(xl) {
      max-width: 600px;
    }
  }
}
</style>
